module.exports = __webpack_public_path__ + "static/fonts/Roboto-Bold.d279e1f.woff";